// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3jAhK","footer":"ChangeClinic_footer__2NsHo"};